import { adminNotFoundRoute, coreAdminRoutes } from "./coreRoutes";
import { featureRouteTree } from "./featureRoutes";
import { rootRoute } from "./rootRoute";

export const adminRouteTree = rootRoute.addChildren([
  ...coreAdminRoutes,
  ...featureRouteTree,
  adminNotFoundRoute,
]);
